import React, { useContext, useEffect } from 'react';
import { AgendaStreamingContext } from '../../common/AgendaStreamingContextProvider';
import Betslip from '../../common/Betslip';
import FavoritesContextProvider from '../../common/FavoritesContextProvider';
import GoUpBtn from '../../common/GoUpBtn';
import GoUpParag from '../../common/GoUpParag';
import LiveContext from '../../contexts/LiveContext';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { setAvailableSpaceForTables } from '../../tables-utils';
import { useLayout } from '../../UISettingsProvider';
import AgendaStreamingCompetition from '../common/AgendaStreamingCompetition';
import LiveSection from '../common/LiveSection';
import LiveScoresDisclaimer from '../common/LiveScoresDisclaimer';

function MultiBet(props) {
    const layout = useLayout();
    const liveContext = useContext(LiveContext);
    const agendaStreamingContext =  useContext(AgendaStreamingContext);
    const betslipContext = useContext(BetslipContext);

    // Abilita scrolling
    useEffect(function() {
        window.setHeight();
        setAvailableSpaceForTables();
    });

    useEffect(function() {
        agendaStreamingContext.setShowAgendaStreaming(props.openAgendaStreaming);
    },[props.openAgendaStreaming]);

    return (
        <div className="container-fluid pagina-sport bg-grigio-chiaro padding-su-1x">
            <div className="row no-gutters sport-griglia">
                <div className={"griglia-centrale-sport col stringimento-sidebar "+ layout.order.divCentrale} id="div-centrale">
                    <div className="contenitore-schedine-sport">
                        <div className={`competizione-interna ${agendaStreamingContext.showAgendaStreaming?'livesuite-gruppo dueColonne':'multibet-gruppo'}`}>
                            <div id="primo-blocco-sport" className="sport-blocco primo-blocco-sport go-up-arrow-on-overflow">
                                <GoUpBtn />
                                <FavoritesContextProvider>
                                    <LiveSection openMatch={liveContext.openMatch} isLiveSuite={false} moreBetsEnabled={true} />
                                    <LiveScoresDisclaimer />
                                </FavoritesContextProvider>
                                {/* <Legend /> */}
                                <GoUpParag/>
                            </div>
                            {agendaStreamingContext.showAgendaStreaming &&
                                <div id="secondo-blocco-sport" className="sport-blocco secondo-blocco-sport tablesCompacted go-up-arrow-on-overflow">
                                    <AgendaStreamingCompetition />
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {
                betslipContext.betslipData && 
                    <Betslip />
                }
            </div>
        </div>
    );
}
      
export default MultiBet;